//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useCallback } from 'react';
import { makeStyles } from '@material-ui/core';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { getFormattedTime } from '../../common/dateHelper';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdTypography from '../../common/elemental/AfitdTypography';
import AfitdAvatar from '../../common/elemental/AfitdAvatar';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
import MessageFileBlock from './MessageFileBlock';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
import cx from 'clsx';
// import { format } from 'date-fns';
import _get from 'lodash/get';
// import _set from 'lodash/set';
import _map from 'lodash/map';
import _defaultTo from 'lodash/defaultTo';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        //chatRightBlock2Content
        root: {
            display: 'flex',
            justifyContent: 'flex-start',
            padding: '0 0 23px 0',
        },
        chatRightBlock2ProfileImageContainer: {
            marginRight: '7px',
        },
        profileImage: {
            // clipPath: 'circle(50% at center)',
            // '-webkit-clip-path': 'circle(50% at center)',
            width: 47,
            height: 47,
        },
        //chatRightBlock2Inn
        chatRightBlock2MessageContainer: {
            width: '64%',
        },
        attachmentContainer: {
            marginTop: '6px',
        },
        //chatRightBlock2In p.doc + img + my own
        contentContainerIn: {
            background: '#fff3ea', //'#e2f7f8',
            border: '1px solid #fc821f', //'1px solid #1d8b8c',
            padding: '12px',
            borderRadius: '10px',
            wordWrap: 'break-word',
        },
        // //amet p.doc
        // contentContainerInNew: {
        //     background: '#fff3ea',
        //     border: '1px solid #fc821f',
        //     padding: '12px',
        //     borderRadius: '10px',
        // },
        //document
        documentContainer: {
            display: 'flex',
            padding: '14px 0 14px 16px',
            border: '2px solid #f7f8fa',
            borderRadius: '10px',
            margin: '5px 0 0 0',
        },
        documentTypeImageContainer: {
            // margin: '14px 0 14px 16px',
        },
        documentInfoContainer: {
            marginLeft: '20px',
        },
        //chatRightBlock2In small
        messageAgeText: {
            marginLeft: '10px',
            fontSize: '13px',
        },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes, props } = params;
    const { createDt, senderProfileImageUrl, attachment } = props;

    const { attachmentContainer: attachmentContainerCls, hidden: hiddenCls } = classes;

    let createDtText = '';
    if (createDt) {
        createDtText = getFormattedTime(createDt);
    }

    const defns = {
        profileImage: {
            src: senderProfileImageUrl,
            alt: `company logo`,
        },
        messageAgeText: {
            variant: 'caption',
            clsMidGrayColor: true,
            value: createDtText,
        },
        attachmentContainer: {
            className: cx(attachmentContainerCls, { [hiddenCls]: !attachment }),
        },
        attachment: {
            attachment,
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const MessageBlockIn = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();
    // const context = useContext(LayoutContext);
    // const xxxxxx = _get(context, 'xxxxxx');

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [yyyyyyyyy, setYyyyyyyyy] = useState();

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const content = _defaultTo(_get(props, 'content'), '');

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    // useEffect(() => {
    //     const newDefns = getDefns(props, { });
    //     setDefns(newDefns);
    // }, [props]);

    //---------------------------------------------------------------------
    // useCallback
    //---------------------------------------------------------------------
    // Break up the message by newline (if any)
    const getFormattedContent = useCallback(() => {
        const contentSplit = content.split('\n');
        return _map(contentSplit, (str, idx) => {
            const defn = {
                key: `inMessage-${idx}`,
                variant: 'body1',
                clsLightBold: false,
                value: str,
            };
            return <AfitdTypography {...defn} />;
        });
    }, [content]);

    //---------------------------------------------------------------------
    // Defns
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.root}>
            <div {...defns.chatRightBlock2ProfileImageContainer}>
                <AfitdAvatar {...defns.profileImage} />
            </div>
            <div {...defns.chatRightBlock2MessageContainer}>
                {content && <div {...defns.contentContainerIn}>{getFormattedContent(content)}</div>}
                <div {...defns.attachmentContainer}>
                    <MessageFileBlock {...defns.attachment} />
                </div>
                <div>
                    <AfitdTypography {...defns.messageAgeText} />
                </div>
            </div>
        </div>
    );
};

export default MessageBlockIn;
